export default "__VITE_ASSET__cz8sSEvW__"